import { useEffect } from "react"
import { useSearchParams, useParams } from "react-router-dom"

import useFetch from "shared/model/useFetch"
import useAlertModalAtom from "shared/model/useAlertModalAtom"

const useGetExamList = () => {
    const [searchParams] = useSearchParams()
    const page = searchParams.get("page")
    const proGrade = searchParams.get("proGrade")

    const [fetchResult, fetchRequest] = useFetch()
    const [, setAlert] = useAlertModalAtom()

    useEffect(() => {
        fetchRequest("GET", `/admin/exam/list?page=${page}&type=${proGrade}`)
    }, [page, proGrade])

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 400:
                if (fetchResult?.data?.error_code === "page") setAlert("페이지 번호 입력 양식을 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "type") setAlert("시험 종류 입력 양식을 확인해 주세요.")
                else setAlert("입력한 값의 형식이 잘못되었습니다.")
                break
        }
    }, [fetchResult])

    return [fetchResult]
}

export default useGetExamList